import { SalesOrderStatus } from './sales-order-status.js';
/** Temporal workflow stage — matches the `stage` field on SalesOrderWorkflowState */
export var SalesOrderWorkflowStage;
(function (SalesOrderWorkflowStage) {
    SalesOrderWorkflowStage[SalesOrderWorkflowStage["ESTIMATE"] = 1] = "ESTIMATE";
    SalesOrderWorkflowStage[SalesOrderWorkflowStage["SUBMITTED"] = 2] = "SUBMITTED";
    SalesOrderWorkflowStage[SalesOrderWorkflowStage["ACCEPTED"] = 3] = "ACCEPTED";
    SalesOrderWorkflowStage[SalesOrderWorkflowStage["SHIPPED"] = 4] = "SHIPPED";
    SalesOrderWorkflowStage[SalesOrderWorkflowStage["COMPLETE"] = 5] = "COMPLETE";
    SalesOrderWorkflowStage[SalesOrderWorkflowStage["CANCELLED"] = 6] = "CANCELLED";
    SalesOrderWorkflowStage[SalesOrderWorkflowStage["AWAITING_APPROVAL"] = 7] = "AWAITING_APPROVAL";
    SalesOrderWorkflowStage[SalesOrderWorkflowStage["REJECTED"] = 8] = "REJECTED";
    SalesOrderWorkflowStage[SalesOrderWorkflowStage["DELIVERY_SCHEDULING"] = 9] = "DELIVERY_SCHEDULING";
    SalesOrderWorkflowStage[SalesOrderWorkflowStage["READY_TO_DELIVER"] = 10] = "READY_TO_DELIVER";
})(SalesOrderWorkflowStage || (SalesOrderWorkflowStage = {}));
/** Identity map — kept explicit (rather than a cast) so an unmapped key fails typecheck. */
export const SALES_ORDER_WORKFLOW_STATUS_TO_DB = {
    SUBMITTED: SalesOrderStatus.SUBMITTED,
    ACCEPTED: SalesOrderStatus.ACCEPTED,
    AWAITING_APPROVAL: SalesOrderStatus.AWAITING_APPROVAL,
    REJECTED: SalesOrderStatus.REJECTED,
    DELIVERY_SCHEDULING: SalesOrderStatus.DELIVERY_SCHEDULING,
    READY_TO_DELIVER: SalesOrderStatus.READY_TO_DELIVER,
    SHIPPED: SalesOrderStatus.SHIPPED,
    COMPLETE: SalesOrderStatus.COMPLETE,
    CANCELLED: SalesOrderStatus.CANCELLED,
};
//# sourceMappingURL=sales-order-workflow-stage.js.map